import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  styled,
} from '@mui/material'

import config from '../../config'
import { colors } from '../../utils/colorUtils'

const Loading = styled(CircularProgress)(({ theme }) => ({
  color: colors.awaOffWhite,
  marginRight: theme.spacing(1),
  marginTop: theme.spacing(1),
  width: '40px',
  height: '40px',
}))

const AuthButtonMenuTitle = styled(MenuItem)(() => ({
  fontSize: '0.8rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  '&.Mui-disabled': { opacity: 0.75 },
}))

const AuthButtonMenuItem = styled(MenuItem)(() => ({
  fontSize: '0.8rem',
  '&.Mui-disabled': { opacity: 0.75 },
}))

const AuthButton = ({ sx }) => {
  const { isLoading, error, user, isAuthenticated, loginWithRedirect, logout } =
    useAuth0()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // redirect user to home page after logout.
  // this returnTo must match a whitelist configured with Auth0
  const logoutWithRedirect = () => {
    logout({ returnTo: window.location.origin })
  }

  // redirect user back to current page after login.
  // appState will get passed back through after redirect (see App.js)
  const login = () => {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname },
    })
  }

  // if auth is disabled, hide the login button
  if (!config.authEnabled) {
    return null
  }

  let content = null
  if (!error) {
    if (isLoading) {
      content = <Loading />
    } else {
      if (isAuthenticated) {
        content = (
          <>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <img
                src={user.picture}
                alt={`Logged in as ${user.name}`}
                width="40"
                style={{
                  border: `3px solid ${colors.awaOffWhite}`,
                  borderRadius: '20px',
                  zIndex: 1400,
                }}
              />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
              sx={{
                '& .MuiMenu-paper': { p: 1 },
              }}
            >
              <AuthButtonMenuTitle disabled>
                Account
              </AuthButtonMenuTitle>
              <AuthButtonMenuItem disabled>
                {`Logged in as ${user.name}`}
              </AuthButtonMenuItem>
              <Divider sx={{ mx: 2 }} />
              <AuthButtonMenuItem onClick={logoutWithRedirect}>
                Log Out
              </AuthButtonMenuItem>
            </Menu>
          </>
        )
      } else {
        content = (
          <Button
            sx={{
              color: colors.awaOffWhite,
              fontSize: '1.0em',
              fontWeight: 400,
              mr: 0.5,
              mt: 0.75,
              zIndex: 1400,
            }}
            onClick={login}
          >
            Log In
          </Button>
        )
      }
    }
  }

  return <Box sx={sx}>{content}</Box>
}

export default AuthButton
